'use client';

import { useEffect, useState } from 'react';

import { useUser } from '@/api/api-hooks/auth-hooks';
import { API_URL } from '@/api/auth/auth';
import { AuthStore } from '@/features/stores/AuthStore';
import {
  clearAccessToken,
  clearRefreshToken,
  getStoredRefreshToken,
  setTokens,
} from '@/features/stores/TokensStore';

function AuthInitializer() {
  const { data: user, isLoading } = useUser();
  const [refreshAttempted, setRefreshAttempted] = useState<boolean>(false);

  useEffect(() => {
    if (user) {
      AuthStore.setState((s) => ({
        ...s,
        isAdmin: user.role === 'admin',
        isInitialized: true,
      }));
    } else if (!isLoading && refreshAttempted) {
      AuthStore.setState((s) => ({
        ...s,
        isInitialized: true,
      }));
    }
  }, [user, isLoading, refreshAttempted]);

  useEffect(() => {
    const tryRefresh = async () => {
      const refresh = getStoredRefreshToken();
      if (!refresh) {
        setRefreshAttempted(true);
        AuthStore.setState((s) => ({ ...s, isInitialized: true }));

        return;
      }

      try {
        const res = await fetch(`${API_URL}/auth/refresh`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ refresh_token: refresh }),
        });

        if (!res.ok) throw new Error('Refresh failed');

        const { access_token, refresh_token } = await res.json();

        setTokens(access_token, refresh_token);
        AuthStore.setState((s) => ({ ...s, isLogin: true }));
      } catch (e) {
        console.warn('Silent refresh failed:', e);
        clearRefreshToken();
        clearAccessToken();
        AuthStore.setState((s) => ({
          ...s,
          isLogin: false,
          isAdmin: false,
        }));
      } finally {
        setRefreshAttempted(true);
      }
    };

    tryRefresh();
  }, []);

  return null;
}
export default AuthInitializer;
